<script lang="ts">
    /**
 *
 *
 *
 *
 *
 *
 */
    import type { $Fetch } from 'ofetch';
    import { defaultFetchClient } from '@shared/clients/BrowserFetchClient.browser.ts';
    import ApmBoundary from '@shared/components/apm-boundary/ApmBoundary.svelte';
    import Esi from '@shared/components/esi/Esi.svelte';
    import type { Logger } from '@shared/types/types';
    import { log } from '../../log.browser';
    import { DynamicEsiClient } from './DynamicEsiClient.ts';

    interface Props {
        src: string;
        name: string;
        fetchClient?: $Fetch;
        logger?: Logger;
        baseURL?: string;
        timeout?: number;
        /**
 *
 *
 *
 *
 *
 */
        onEmptyChange?: (empty: boolean) => void;
    }

    let {
        src,
        name,
        fetchClient = defaultFetchClient,
        logger = log,
        baseURL,
        timeout,
        onEmptyChange = () => {},
    }: Props = $props();

    const client = $derived(new DynamicEsiClient({ name, fetchClient, logger, baseURL, timeout }));

    /*                                                       */
    /*                                     */
    let lastSrc: string | undefined = src;

    let container: HTMLElement | undefined = $state();

    $effect(() => {
        if (lastSrc === src && !hasUnresolvedInclude()) {
            return;
        }
        lastSrc = src;
        fetchAndReplace(src);
    });

    /**
 *
 *
 *
 *
 */
    function hasUnresolvedInclude(): boolean {
        return !!container?.querySelector('esi\\:include');
    }

    async function fetchAndReplace(url: string) {
        if (!container) {
            return;
        }

        try {
            const html = await client.getHtml(url);
            replaceFragment(html);
        } catch (err) {
            log.info(`[DynamicEsi] Failed to fetch ${url}`, err);
            clearContainer();
        }
    }

    function replaceFragment(html: string) {
        if (!container || !html) {
            clearContainer();
            return;
        }
        /*                                                                                */
        const range = document.createRange();
        range.selectNodeContents(container);
        const fragment = range.createContextualFragment(html);
        range.deleteContents();
        range.insertNode(fragment);
        onEmptyChange(false);
    }

    function clearContainer() {
        if (!container) {
            return;
        }
        const range = document.createRange();
        range.selectNodeContents(container);
        range.deleteContents();
        onEmptyChange(true);
    }
</script>

<ApmBoundary scope={name}>
    <div bind:this={container} style="display: contents">
        <Esi {src} />
    </div>
</ApmBoundary>
